import { Breadcrumbs } from '@components/display/breadcrumbs';
import { getBreadcrumbsFromPath } from '@utils/route';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

export const MediaBrowserToolbar = ({ extraButton }: { extraButton?: React.ReactNode }) => {
    const { pathname } = useLocation();
    const intl = useIntl();

    const path = useMemo(() => getBreadcrumbsFromPath(pathname, intl), [intl, pathname]);

    return <Breadcrumbs viewSwitcher path={path} extraButton={extraButton} />;
};
